import { render } from "./TokenList.vue?vue&type=template&id=24e56145&scoped=true"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"

import "./TokenList.vue?vue&type=style&index=0&id=24e56145&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e56145"]])

export default __exports__